<template>
  <div id="reviews-distribution-by-month-chart" class="w-full" />
  <TheNoResult
    v-if="noData"
    :image="imgUrl"
    :title="$t('pages.review.reviewAnalyticsPage.chart.noResults.title')"
    :description="$t('pages.review.reviewAnalyticsPage.chart.noResults.description')"
  />
</template>

<script>
import TheNoResult from '@/components/layout/TheNoResult.vue'
import { PieChart } from '@/components/charts/PieChart'
import useReview from '@/composables/review'
import ApexChart from 'apexcharts'

export default {
  name: 'ReviewsDistributionByPlatform',
  components: {
    TheNoResult
  },
  setup() {
    const { reviewStatistics } = useReview()
    const imgUrl = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/review-analytics/review-distribution.png`)
    return {
      reviewStatistics,
      imgUrl
    }
  },
  data: () => {
    return {
      chartInstance: null,
      chart: new PieChart(),
      categories: [],
      formattedData: []
    }
  },
  computed: {
    noData() {
      return this.data.length === 0
    },
    data() {
      return this.reviewStatistics.reviewsDistributionByPlatform
    }
  },
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy()
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    resolveMoodLabelBySlug(slug) {
      return this.$t(`pages.review.reviewSettingsPage.templates.form.mood.${slug}`)
    },
    initChart() {
      this.formatData()
      if (!this.noData) {
        const chartElement = this.createElement('reviews-distribution-by-month-chart')
        this.chart.setColor(['#EC654E', '#4ED6A3', '#3B5998'])
        this.chart.setLabels(this.categories)
        this.chart.setSeries(this.formattedData)
        this.chartInstance = new ApexChart(chartElement, this.chart.options)
        this.chartInstance.render()
      }
    },
    formatData() {
      this.data.forEach((d) => {
        if (!this.categories.includes(d.platform_name)) {
          this.categories.push(d.platform_name)
          this.formattedData.push(d.reviews_number)
        }
      })
    },
    createElement(ref) {
      let elem = document.getElementById(ref)
      let chartElement = document.createElement('div')
      chartElement = elem.appendChild(chartElement)
      chartElement.setAttribute('id', `${ref}-apex`)
      return chartElement
    }
  },
  render(ce) {
    return ce('div')
  }
}
</script>
